import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AlertTriangle } from 'lucide-react';

const ContractDeleteModal = ({ show, onClose, onSuccess, contractData }) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const [error, setError] = useState(null);

    const handleDelete = async () => {
        if (!contractData || !contractData.id) {
            setError('Vertrags-ID fehlt');
            return;
        }

        setIsDeleting(true);
        setError(null);

        try {
            const response = await fetch('/index.php/contracts/deleteContractJSON', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id: contractData.id })
            });

            const result = await response.json();

            if (result.success) {
                onSuccess();
            } else {
                setError(result.error || 'Fehler beim Löschen des Vertrags');
            }
        } catch (err) {
            console.error('Error deleting contract:', err);
            setError('Fehler beim Löschen des Vertrags');
        } finally {
            setIsDeleting(false);
        }
    };

    const handleClose = () => {
        setError(null);
        onClose();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton style={{ borderBottom: '1px solid var(--border-light, #e2e8f0)' }}>
                <Modal.Title style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    fontSize: '1.125rem',
                    fontWeight: 600,
                    color: 'var(--text-primary, #2c3e50)'
                }}>
                    <AlertTriangle size={24} style={{ color: '#ef4444' }} />
                    Vertrag löschen
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '1.5rem' }}>
                {error && (
                    <div className="alert alert-danger mb-3" role="alert">
                        {error}
                    </div>
                )}
                <p style={{ margin: 0, color: 'var(--text-primary, #2c3e50)' }}>
                    Möchten Sie den Vertrag <strong>"{contractData?.title}"</strong> wirklich löschen?
                </p>
                <p style={{
                    margin: '1rem 0 0 0',
                    fontSize: '0.875rem',
                    color: 'var(--text-secondary, #64748b)'
                }}>
                    Diese Aktion kann nicht rückgängig gemacht werden. Der Vertrag wird aus der Vorlagenliste entfernt.
                </p>
            </Modal.Body>
            <Modal.Footer style={{
                borderTop: '1px solid var(--border-light, #e2e8f0)',
                padding: '1rem 1.5rem',
                gap: '0.75rem'
            }}>
                <Button
                    variant="outline-secondary"
                    onClick={handleClose}
                    disabled={isDeleting}
                    style={{
                        border: '1px solid var(--border-medium, #cbd5e1)',
                        color: 'var(--text-primary, #2c3e50)',
                        background: 'var(--bg-card, #ffffff)'
                    }}
                >
                    Abbrechen
                </Button>
                <Button
                    variant="danger"
                    onClick={handleDelete}
                    disabled={isDeleting}
                    style={{
                        background: '#ef4444',
                        border: 'none'
                    }}
                >
                    {isDeleting ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                            Löschen...
                        </>
                    ) : (
                        'Löschen'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ContractDeleteModal;
